import React, { useEffect, useState } from "react"
import profile from "../images/profile.png"
import dropDown from "../images/dropdown2.png"
import help from "../images/help.png"
import dropUp from "../images/dropup.webp"
import "../styles/UserSettings.css"
import {
    Alert,
    Button,
    Form,
    Input,
    Modal,
  } from 'antd';
  import { Button as MuiButton } from "@mui/material"
  import { EyeTwoTone } from '@ant-design/icons';
  import { CloseOutlined  } from '@ant-design/icons';
  import { EyeInvisibleOutlined } from '@ant-design/icons';
  import CircularProgress from '@mui/material/CircularProgress';
  import axios from 'axios';
  import { Navigate, useNavigate } from 'react-router-dom';
  import ProfilePicture from './profilePicture';
  import {motion} from "framer-motion"

export default function UserSettings ({propsData}) {
     
    let [profileData,setProfileData]=useState({
        username:propsData.userData.data.username,
        email:propsData.userData.data.email,
        password:"",
        confirmPassword:"",
        profile:propsData.userData.data?.profilePicture,
        id:propsData.userData?.data?._id
      })
      
      let [passwordConfirmed,setPasswordConfirmed]=useState(false)
      ///Show wheather password is confirmed
      useEffect(()=>{
        if(profileData.confirmPassword!==profileData.password){
          setPasswordConfirmed(true)
        }
        else {
          setPasswordConfirmed(false)
        }
      },[profileData.confirmPassword,profileData.password])
      
      ///Show the confirmtion button
      let [hideConfirmePAsswordButto,setHideConfirmePAsswordButto]=useState(false)

      useEffect(()=>{
        if(profileData.password===""){
          setHideConfirmePAsswordButto(true)
        }
        else{
          setHideConfirmePAsswordButto(false)
        }
      
      },[profileData.password])
      ////.log("form ",userData);
      
      let [disAbleUpdateButton,setDisAbleUpdateButton]=useState(true)
      let valueNotChanged=profileData.username===propsData.userData.data.username&&
        profileData.email===propsData.userData.data.email&&
        profileData.password===""
        let[InValidEmail,setInValidEmail]=useState(false)
      
        const isValidEmail = (email) => {
          const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
          return emailRegex.test(email);
        }
      
      useEffect(()=>{
        if(isValidEmail(profileData?.email)){
          setInValidEmail(false)
        }
        else{
          setInValidEmail(true)
        }
      },[profileData.email])
      
      useEffect(()=>{
      
        if(valueNotChanged){
          //.log("not updated")
          setDisAbleUpdateButton(true)                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
      }
      else{
        setDisAbleUpdateButton(false)
      }
      },[profileData,propsData.userData])
      
      
      function formChanged(element){
      
        setProfileData(e=>{
          return {
            ...e,
            [element.target.name]:element.target.value
          }
        })
      }
      //////are u sure componenet
      let [beSurePage,setBeSurrPage]=useState(false)
      function updateValue(){
        setBeSurrPage(true)
      }
      function amNotSureToChanges(){
        setBeSurrPage(false)
      }
      ////.log(userData.data.token);
      let [isLoading,setLoading]=useState(false)
      let [error,GetError]=useState(false)
      let [success,GetSuccess]=useState(false)
      
      
      async function amSureToChanges(){
              setLoading(true)
              setBeSurrPage(false)
              if(!profileData.password){
                delete profileData["password"]
              }
              //let stringfyValue=JSON.stringify(profileData)
              //.log("Updated profileData ",stringfyValue);
              axios.put(`${process.env.REACT_APP_URL}/api/user/update`,profileData, //proxy uri
                {
                  headers: {
                      authorization:`Bearer ${propsData.userData.token}`,
                    'Content-Type': 'application/json'
                  } 
              }).then(function (response) {
                  setLoading(false)
                  profileData["password"]=""
                  GetSuccess("Successfuly updated")
                  propsData.setEquilizer(propsData.equilizer+2)
                  setTimeout(()=>{
                    GetSuccess("")
                  },3000)
              }).catch((error) => {
                  setLoading(false)
                  profileData["password"]=""
                  console.log(error);
                if (error.response) {
                  GetError(error?.response?.data?.error||"Error occured check your internate connection and try again ");
                  //.log("server responded");
                } else {
                  GetError("Error occured check your internate connection and try again ");
                }
                setTimeout(()=>{
                  GetError("")
                },3000)
              });
      }
      
     
      
      //delete account
    const [activePrivacySecurity, setActivePrivacySecurity] = useState(false);
    const [activeHelp, setActiveHelp] = useState(false);


    //console.log(propsData.userData);
    let navigate=useNavigate()

    const LoggedOut=()=>{
       propsData.setUserData({logged:false,data:{}})
       localStorage.removeItem('895u64jxdnvjkf-ghdfjg65-duindjdb-bdaab-a35553-mlfdc');
       localStorage.removeItem('895u64jxdnvjkf-jfndfjk-95y357348jnvdf-40369');
       localStorage.removeItem('895u64jxdnvjkf-ghdfjg65745cnx-gncmghnfgs5-zg-aethb Bth-5gsdfggdbz');
       navigate("/")
    } 
    
    return (
        <div className="user-settings-container">
          <ProfilePicture equilizer={propsData.equilizer} setEquilizer={propsData.setEquilizer} userData={propsData.userData} setUserData={propsData.setUserData} username={profileData.username} profile={profileData.profile}/>
          <section className='user-settings-container-form'>
            <div  className='user-settings-container-form-componrnt'>
                <div className='user-settings-container-form-component-title'>Username</div>
                  <div className='user-settings-container-form-input'>  
                      <Input
                      onChange={formChanged}
                      name='username'
                      value={profileData.username}
                      />     
                  </div> 
                  <div className='error'></div>
              </div>
            
              <div className='user-settings-container-form-componrnt'>
                <div className='user-settings-container-form-component-title'>Email</div>
                  <div>  
                    <Input type='email'
                    onChange={formChanged}
                    name='email'
                    style={{borderColor:InValidEmail&&"red"}}
                    value={profileData.email}
                    />     
                  </div> 
                  <div  className='error'>{InValidEmail&&"Invalid Email"}</div>
            </div>

              <div className='user-settings-container-form-componrnt'>
                  <div  className='user-settings-container-form-component-title'>Password</div>
                  <div className='user-settings-container-form-input'>  
                    <Input.Password
                    onChange={formChanged}
                    name='password'
                    value={profileData.password}
                    />     
                  </div> 
                  <div className='error'></div>
              </div>

              <div className='user-settings-container-form-componrnt'  style={{display:hideConfirmePAsswordButto&&"none"}}>
                  <div className='user-settings-container-form-component-title'>Confirm Password</div>
                  <div className='user-settings-container-form-input'>  
                    <Input.Password
                    onChange={formChanged}
                    name='confirmPassword'
                    value={profileData.confirmPassword}
                    />     
                  </div> 
                  <div className='error'>{passwordConfirmed&&"Password is not confirmed"}</div>
              </div>
              <div>{error&&<Alert message={error}type="error" showIcon />} </div>
              <div>{success&&<Alert message={success}type="success" showIcon />} </div>
              {isLoading?<div style={{textAlign:"center"}}><CircularProgress size={24} color="success"/></div>:
                <div className='update-button' >
                   <MuiButton  onClick={updateValue} disabled={(passwordConfirmed&&!hideConfirmePAsswordButto)||disAbleUpdateButton||InValidEmail}>
                          Update
                </MuiButton></div>}
          </section>
          {beSurePage&&
          <section className='user-settings-update-makeSure'>
                <motion.div 
                  initial={{scale:0,opacity:0}}
                  animate={{scale:1,opacity:1}}
                  transition={{duration:0.6}}
                  className='user-settings-update-makeSure-makeCenter'>
                    <div className='user-settings-update-makeSure-makeCenter-icon'><Button  onClick={amNotSureToChanges} ><CloseOutlined  className='icon'/></Button></div>
                    <div>Are You sure on make changes?</div>
                    <div className='user-settings-update-makeSure-button'>
                      <div><Button onClick={amSureToChanges} type="primary">yes</Button></div>
                      <div><Button onClick={amNotSureToChanges} type="primary" danger>no</Button></div>
                    </div>
                </motion.div>
          </section>}

            <div className="user-settings-edited-data">
              
                <div className="user-settings-detail">
                    <div className="user-settings-privacy-security-detail">
                        <div style={{width:activePrivacySecurity&&"60%"}} className="user-settings-privacy-and-security" onClick={() => setActivePrivacySecurity(!activePrivacySecurity)}>
                            <div>Privacy and Security</div>
                            <div><img src={activePrivacySecurity ? dropUp : dropDown} className="user-settings-icon" /></div>
                        </div>

                        {activePrivacySecurity && 
                          <div className="user-settings-privacy-security-detail-description">
                            <ol>
                                <li>Secure website: The website should have a secure connection with SSL (Secure Sockets Layer) encryption. This ensures that all data transmitted between the customer's browser and the website is encrypted and cannot be intercepted by hackers.</li>
                                <li>Payment gateway: The payment gateway should be secure and use industry-standard encryption to protect the customer's financial information.</li>
                                <li>Two-factor authentication: E-commerce businesses should implement two-factor authentication for customer accounts to prevent unauthorized access.</li>
                                <li>Privacy policy: A clear and comprehensive privacy policy should be in place, outlining how customer data is collected, stored, and used.</li>
                                <li>Regular security audits: E-commerce businesses should conduct regular security audits to identify and address any vulnerabilities in their systems.</li>
                                <li>Data protection: E-commerce businesses should comply with data protection laws and regulations, such as GDPR (General Data Protection Regulation) in the EU, to protect customer data.</li>
                            </ol>
                            <input className="user-settings-privacy-security-input" type="checkbox" />
                            <label>Agree with all terms and continue</label>
                        </div> }
                    </div>

                    <div className="user-settings-help">
                        <div className="user-settings-help-detail">
                            <div className="user-settings-help-top"  style={{width:activeHelp&&"60%"}} onClick={() => setActiveHelp(!activeHelp)}>
                                <div  className="user-settings-help-title">
                                    <img src={help} className="user-settings-help-icon" />
                                    <div>Help</div>
                                </div>
                                <img src={activeHelp ? dropUp : dropDown} className="user-settings-icon" />
                            </div>
                            {activeHelp && <div className="user-settings-help-detail-description">
                                <ol>
                                    <li>Secure password policies: E-commerce businesses should require customers to create strong passwords that are difficult to guess. They should also encourage customers to change their passwords regularly.</li>
                                    <li>User access controls: E-commerce businesses should restrict access to sensitive data, such as customer payment information, to only authorized personnel. They should also implement user access controls to ensure that employees only have access to the data that they need to perform their job functions.</li>
                                    <li>Fraud detection and prevention: E-commerce businesses should have fraud detection and prevention measures in place to identify and prevent fraudulent transactions. These measures may include using machine learning algorithms to analyze transaction patterns and flag suspicious activity.</li>
                                    <li>Customer education: E-commerce businesses should educate their customers on how to protect their personal and financial information online. This may include providing tips on creating strong passwords, avoiding phishing scams, and using secure networks when making online purchases.</li>
                                    <li>Secure third-party integrations: E-commerce businesses may integrate with third-party services, such as payment gateways or shipping providers. It's important to ensure that these integrations are secure and comply with data protection laws.</li>
                                </ol>
                            </div>}
                        </div>
                    </div>
                    
                </div>
                <div className="user-settings-buttons">
                     <div  className="user-settings-button"> <MuiButton>Delete Account</MuiButton></div>
                     <div  className="user-settings-button">  <MuiButton onClick={LoggedOut}>Log out</MuiButton></div>
                </div>
            </div>
        </div>
    )
}